import { Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  thirdPartyText: string;
  thirdPartyScreenshot: string | null;
  thirdPartyTextPlaceholder: string | undefined;
  thirdPartyTextAriaLabel: string | undefined;
  thirdPartyTextType: string | undefined;
  thirdPartyClickLoading: boolean;

  handleThirdPartyTextChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleSetThirdPartyTextFromAppSync(): void;
}

const ThirdPartyText: React.FC<Props> = ({
  thirdPartyText,
  thirdPartyScreenshot,
  thirdPartyTextPlaceholder,
  thirdPartyTextAriaLabel,
  thirdPartyTextType,
  thirdPartyClickLoading,
  handleThirdPartyTextChange,
  handleSetThirdPartyTextFromAppSync,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack className={classes.enter2fa} gap={3}>
      <Typography className={classes.bigHighlightText} align={'center'}>
        {t('appSyncSetThirdPartyText')}
      </Typography>
      {!_.isNil(thirdPartyScreenshot) ? (
        <Stack direction={'row'} justifyContent={'center'}>
          <img className={classes.thirdPartyScreenshot} src={thirdPartyScreenshot} alt={'third-party-website'} />
        </Stack>
      ) : null}
      <Stack direction={'row'} justifyContent={'center'}>
        <PaiTextField
          value={thirdPartyText}
          placeholder={thirdPartyTextPlaceholder || t('enterText')}
          label={thirdPartyTextAriaLabel}
          ariaLabel={thirdPartyTextAriaLabel}
          type={thirdPartyTextType}
          style={{ maxWidth: '350px' }}
          onChange={handleThirdPartyTextChange}
          disabled={thirdPartyClickLoading}
        />
      </Stack>
      <Stack direction={'row'} justifyContent={'flex-end'}>
        <PaiButton text={t('next')} border={'rounded'} action={handleSetThirdPartyTextFromAppSync} loading={thirdPartyClickLoading} />
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  enter2fa: {
    width: '100%',
  },
  bigHighlightText: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  greyFormText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
  },
  highlightText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  thirdPartyScreenshot: {
    height: '250px',
    width: 'auto',
    filter: 'saturate(0%)',
  },
}));

export default ThirdPartyText;
